import { HttpResponse, HttpRequestConfig } from '@/utils/http-utils';
import Logger from '@/utils/logger.utils';
import httpService from '@/services/http.service';
import siteConfigService from '@/services/site.config.service';
import AcceptLanguage from '@/entities/accept.language';
import { DEVICE } from '@/entities/device';
import Cookie from '@/utils/cookie-utils';


class BrowserService {
  public static isTouchScreen(): boolean {
    const isTouch: boolean =
      ('ontouchstart' in window)
      || (!!navigator.msMaxTouchPoints && navigator.msMaxTouchPoints > 0)
      || (!!navigator.maxTouchPoints && navigator.maxTouchPoints > 0);
    return isTouch;
  }


  public static unsupportedIEVersion(): boolean {
    const ua = window.navigator.userAgent;
    const isIE: boolean = (ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0 || ua.indexOf('Edge/') > 0);
    return isIE;
  }

  public static unsupportedIEVersionWithoutEdge(): boolean {
    const ua = window.navigator.userAgent;
    const isIE: boolean = (ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0);
    return isIE;
  }

  public static async getBrowserLanguage(): Promise<string> {
    if (BrowserService.browserLanguageNotAvailableInJS()) {
      const apiEndpoint: any = await siteConfigService.getApiEndpoint('generic.browserLanguage');
      const config: HttpRequestConfig = {
        useBrowserLanguageSetting: true,
      };
      Logger.debug(`browserLanguage apiEndpoint=${apiEndpoint}`);
      const messageMapRes: HttpResponse<AcceptLanguage> = await httpService.get<AcceptLanguage>(apiEndpoint, config);
      const acceptLanguage: AcceptLanguage = messageMapRes.data;
      if (acceptLanguage && acceptLanguage.acceptLanguage) {
        const languages: Array<string> = acceptLanguage.acceptLanguage.split(',') || ['en'];
        if (languages) {
          let languageCode: string = languages[0].trim();

          let pos : number = languageCode.indexOf(';');
          if (pos >= 0) {
            languageCode = languageCode.substring(0, pos);
          }

          pos = languageCode.indexOf('-');
          if (pos >= 0) {
            languageCode = languageCode.substring(0, pos);
          }

          Logger.debug(`languageCode=${languageCode}`);
          return languageCode;
        }
      }
    }
    return BrowserService.getLanguageCodeFromNavigator();
  }

  public static async getLanguageCodeFromNavigator(): Promise<string> {
    const languages: string[] = navigator.languages ? [].concat(navigator.languages) : [];
    const language: string = await BrowserService.getLanguage(languages, navigator.language);
    return language;
  }
  public static async getLanguage(languages: string[], language: string): Promise<string> {
    let languageCode: string = (languages && languages.length > 0) ? languages[0] : language;
    languageCode = languageCode || 'en';
    Logger.debug(`languageCode=${languageCode}`);
    return languageCode;
  }


  public static browserLanguageNotAvailableInJS(): boolean {
    return !window.navigator.languages;
  }

  public static getDevice(): Array<DEVICE> {
    const devices: Array<DEVICE> = new Array<DEVICE>();
    const userAgent = navigator.userAgent.toLowerCase();
    if (/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent)) {
      devices.push(DEVICE.TABLET);
    }
    if (/(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(userAgent)) {
      devices.push(DEVICE.MOBILE);
    }
    if (devices.length === 0) {
      devices.push(DEVICE.DESKTOP);
    }
    const isInNativeAppShellContainer = (Cookie.getCookie('isInNativeAppShellContainerString') === 'true');
    if (isInNativeAppShellContainer) {
      devices.push(DEVICE.APP_SHELL);
      const isInIosNativeAppShellContainer = (Cookie.getCookie('isInIosNativeAppShellContainerString') === 'true');
      if (isInIosNativeAppShellContainer) {
        devices.push(DEVICE.IOS_APP_SHELL);
      } else {
        devices.push(DEVICE.ANDROID_APP_SHELL);
      }
    } else {
      devices.push(DEVICE.NON_APP_SHELL);
    }
    return devices;
  }
}

// Export a singleton instance in the global namespace
export default BrowserService;
